// extracted by mini-css-extract-plugin
export default {"fabricadosL2":"FabricadosL2_fabricadosL2__uvs6P","cards":"FabricadosL2_cards__IoWIg","bigcard":"FabricadosL2_bigcard__NE+0C","map":"FabricadosL2_map__zInKZ"};